/**
 * Action types
 */

export enum latestPostTypes {
  POST_REQUEST = '@latestNews/FETCH_POST_REQUEST',
  POST_SUCCESS = '@latestNews/FETCH_POST_SUCCESS',
  POST_FAILURE = '@latestNews/FETCH_POST_FAILURE'
}

/**
 * Data types
 */

export interface LatestNew {
  id: number
  title: string
  path: string
  alt: string
  author: string
  text: string
  status: string
  scheduled: boolean
  publishedAt: Date | null
  createdAt: string
  fileData: null
  lastEdit: Date | null
  newsCategories: string | null
  newsCategoriesId: number | null
  userId: number | null
  audience: string
  newsModuleListTags: string[]
}

/**
 * State type
 */
export interface LatestNewsState {
  readonly latestNews: LatestNew[]
  readonly loading: boolean
  readonly error: boolean
}

export interface FetchLatestPostsSuccessPayload {
  readonly data: LatestNew[]
}

export interface FetchLatestPostsFailurePayload {
  error: string
}

export interface FetchLatestPostsRequest {
  type: typeof latestPostTypes.POST_REQUEST
}

export type FetchLatestPostsSuccess = {
  type: typeof latestPostTypes.POST_SUCCESS
  payload: FetchLatestPostsSuccessPayload
}

export type FetchLatestPostsFailure = {
  type: typeof latestPostTypes.POST_FAILURE
  payload: FetchLatestPostsFailurePayload
}

export type LatestPostsActions =
  | FetchLatestPostsRequest
  | FetchLatestPostsSuccess
  | FetchLatestPostsFailure
